import { Scene } from './domain'

export type Template = {
  id: number
  templateToken: string
  templateName: string
  templateDescription?: string
  createdAt: string
  rejectReason?: string
  cover: string
  preview: string
  viewCount: number
  usedCount: number
  likes: number
  creatorId: string
  creatorName: string
  creatorAvatarUrl: string
  tags: Tag[]
  gdScene: Scene
  price: number
  status: TemplateStatus
  formToken: string
  fromTemplate?: string
}

export type TemplateDetail = Template & {
  templateBackgroundImage?: string

  ktdDetail: {
    title: string
    description: string
    keywords: string
  }
}

export type PaginationResult<T> = {
  total: number
  list: T[]
  pageNum: number
  pageSize: number
  hasNextPage: boolean
}

export type TemplateTagCategory = {
  id: number
  name: string
  tags: Tag[]
}

export enum SortTemplateBy {
  RELEVANCY = 'relevancy',
  USED_COUNT = 'used_count',
  UPDATED_AT = 'updated_at',
}

export type Tag = {
  id: number
  name: string
  tagOrder: number
}

export enum TemplateStatus {
  WAITING_FOR_APPROVED = 'WAITING_FOR_APPROVED',
  APPROVED = 'APPROVED',
  ON_SHELF = 'ON_SHELF',
  REJECTED = 'REJECTED',
  OUT_OF_SHELF = 'OUT_OF_SHELF',
}

export enum TemplateDeviceType {
  PC = 'PC',
  MOBILE = 'MOBILE',
}

enum TemplateFormLayout {
  CLASSIC = 'classic',
  CARD = 'card',
}

export type GetTemplateArgs = {
  keywords?: string
  /** tag names */
  tags?: string[]
  /** 0: free, 1: paid */
  feeType?: 0 | 1
  layout?: TemplateFormLayout

  sortBy: SortTemplateBy

  page: number
  size: number
}

export type UseTemplateResult = {
  form_token?: string
  success_url?: string
  /** present instead of form_token when the template is paid and unpurchased */
  template_url?: string
}

export type UseTemplateArgs = {
  templateToken: string
  scene: Scene
  folder_id?: string
  tags: string[]

  app_trial_alert?: boolean
  form_app_trial_alert?: boolean
  confirm_unbind_app?: boolean
  confirm_unbind_form_app?: boolean
  confirm_form_app_trial?: boolean
  frm?: string
}

export enum UseTemplateErrorType {
  CAN_FEATURE_TRIAL = 'CAN_FEATURE_TRIAL',
  PAID_FEATURE_REQUIRED = 'PAID_FEATURE_REQUIRED',
  CANNOT_FORM_APP_TRIAL = 'CANNOT_FORM_APP_TRIAL',
  FORM_APP_TRIAL_REQUIRED = 'FORM_APP_TRIAL_REQUIRED',
  UNAVAILABLE_TO_TRIAL_OR_UPGRADE = 'UNAVAILABLE_TO_TRIAL_OR_UPGRADE',
  /** synthesized client-side: backend answers 200 + template_url (no error field) for unpurchased paid templates */
  TEMPLATE_PURCHASE_REQUIRED = 'TEMPLATE_PURCHASE_REQUIRED',
}

export type UseTemplateError = {
  error: UseTemplateErrorType
  in_trial_form_apps?: string[]
  cannot_trial_form_apps?: string[]
  need_trial_form_apps?: string[]
  expire_days?: number
  target_plan?: string
  target_trial_type?: string
  template_url?: string
}

export type TemplateLikeArgs = {
  templateToken: string
  userId: string
  likeId?: number
}

export enum MyTemplateStatus {
  PUBLISHED = 'ON_SHELF',
  AUDITING = 'WAITING_FOR_APPROVED|APPROVED',
  FAILED = 'REJECTED|OUT_OF_SHELF|FIRST_CHECK_REJECTED',
}

export type TemplateTagResult = {
  id: number
  name: string
  tags: Tag[]
}
